var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('v-btn',{attrs:{"color":"red lighten-2","dark":"","loading":_vm.loading},on:{"click":function($event){return _vm.exportData()}}},[_vm._v(" "+_vm._s(_vm.$t('misc.export'))+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }